Controller = App.loadClass 'core::Angular/Controller'

class exports.SidebarController extends Controller
    constructor: (@scope, @transitions, Steps, @state, @loader, @http, @location, @fields, @validation) ->
        super(@scope, @transitions)
        @scope.show_fullpage = false
        @scope.$on '$destroy', () =>
            if @scope.field_data?.boundary_layer?
                App.map.removeLayer(@scope.field_data.boundary_layer)
            @validation.checkBoundary()
            @cleanup()

        # init
        @init(Steps)

    cleanup: () =>
        # clear vars
        delete @scope.field_data
        delete @scope.steps
        @fields_id = undefined
        @year = undefined
        @layer_id = undefined

        @fields.cleanup()
        @validation.cleanup()


    setupForNewProcess: () =>
        # fields add doesn't have any special settings so set them if we're in that mode
        if not @validation.settings?.process_mode?
            @validation.cleanup()
            @validation.settings = { process_mode: 'zone-add' }

        @validation.setupByMode()

    initValidation: () =>
        @validation.setFieldsData()
        @validation.setProcessMode()

    initVariables: () =>
        # first get the process mode
        @process_mode = @validation.process_mode
        # set functions
        @scope.fireValidation = @fireValidation
        @scope.previousStep = @previousStep
        # fetch shared data
        @fields_id = @fields.getFieldsId()
        @year = @fields.getYear()
        @layer_id = @fields.getLayersId()

    init: (Steps) =>
        @setupForNewProcess()
        @initValidation()
        @initVariables()
        # load template data structures
        @initializeDisabledObject()
        @initializeTextObject()
        @initializeFieldData().then () =>
            @initializeSteps(Steps)
            # for validation
            @validation.setMainScope(@scope)
            # take step
            @start()

    initializeDisabledObject: () =>
        @scope.disabled = {
            next: true
            required: false
            back: false
        }

        @scope.disabled.back = true if @process_mode in ['zone-add', 'irrigation-add', 'zone-edit', 'add-crop']

    initializeTextObject: () =>
        @scope.text = {
            next: 'Next'
            back: 'Back'
            required: 'Required *'
        }

    initializeSteps: (Steps) =>
        # create steps object
        @scope.steps = Steps.new()
        @scope.steps.setScope(@scope)
        @scope.steps.setEventPrefix('grower.fields-define')
        # set the callback that needs run when exiting
        @scope.steps.setExitCallback(@exitProcess)
        # create the steps based on the process_mode and then set them
        @scope.steps.setSteps(@makeSteps(@process_mode))

    start: () =>
        # turn state into step
        step = @state.$current.name
        # route process using step
        @routeStep(step)

    initializeFieldData: () =>
        # get mdc ids
        @loadIds().then (ids) =>
            # set mdc ids
            [irrigation_mdc_id, previous_crop_mdc_id, productivity_mdc_id] = ids
            # initialize field_data object with nested steps and zones objects
            @scope.field_data = {
                name: null
                farm: null
                boundary: null,
                id: @fields_id
                process_mode: @process_mode,
                year: @year,
                getAcres: () ->
                    return 0
                zone_unique_id: 0
                zones:
                    'irrigation':
                        zones: []
                        map_data_categories_id: irrigation_mdc_id
                    'previous-crop':
                        zones: []
                        map_data_categories_id: previous_crop_mdc_id
                    'productivity':
                        zones: []
                        map_data_categories_id: productivity_mdc_id

                zone_steps: [
                    { name: 'Irrigation', enabled: false, child_steps: [
                        'grower.fields-define.irrigation-draw',
                        'grower.fields-define.irrigation-settings1',
                        'grower.fields-define.irrigation-settings2',
                    ] }
                    { name: 'Previous Crop', enabled: false, child_steps: [
                        'grower.fields-define.previous-crop-draw'
                        'grower.fields-define.previous-crop-settings1'
                    ] }
                    { name: 'Productivity', enabled: false, child_steps: [
                        'grower.fields-define.productivity-draw'
                        'grower.fields-define.productivity-settings1'
                        'grower.fields-define.productivity-settings2'
                    ] }
                ]
                # final step regardless of process start
                final_step: 'grower.fields-define.finish'
            }

            # check for fieldprint access
            @fields.hasFieldprintAccess().then (response) =>
                # if the user does have fieldprint access
                if response.data.data
                    # set the has access flag on the field data
                    @scope.field_data.has_fieldprint_access = true
                    # allow the optional irrigation details step to be used in the process
                    @scope.field_data.zone_steps[0].child_steps.push 'grower.fields-define.irrigation-details',

    previousStep: () =>
        if @scope.steps.activeStep.state is 'grower.fields-define.locate'
            @state.go 'grower.fields'
        else
            @validation.wentBack()
            @scope.steps.gotoPrevStep()

    fireValidation: (ending) =>
        # prevent double clicking from skipping steps
        @scope.$evalAsync(() =>
            @scope.disabled.next = true
        )

        # define boundary may need to call the next step on its own
        # https://www.pivotaltracker.com/story/show/140247563
        if not @validation.wait_before_next_step
            # move to next step
            @scope.steps.gotoNextStep()

        # run validation on new step to determine button state
        @validation.validate(ending)

    routeStep: (step) =>
        if step is 'grower.fields-define'
            # check editing
            # we are editing
            @scope.field_data.editing = true
            # set field data
            @fields.setFieldData(@scope.field_data)

            # did we get here from data->add or fields->edit?
            if @process_mode is 'zone-add'
                # from data->add
                @routeDataAdd()

            if @process_mode is 'irrigation-add'
                @routeIrrigationAdd()

            if @process_mode is 'zone-edit'
                # from data->view
                @routeDataView()

            if @process_mode is 'add-crop'
                # from fieldprint->add crop
                @routeAddCrop()
        else
            # just passing through to next step
            @step(step)

    routeDataAdd: () =>
        # setup callback for switching steps after loading data
        cb = () =>
            @step('grower.fields-define.select-management-zones')

        if @validation.settings?.year? and @validation.settings?.fid?
            @loadIrrigationZone().then () =>
                @fields.zones.hasExistingPreviousCropZone(@validation.settings.fid, @validation.settings.year).then (response) =>
                    @scope.field_data.zones['previous-crop'].has_existing = response.data.data
                    # load field data
                    @fields.load(cb)
        else
            @fields.load(cb)

    routeIrrigationAdd: () =>
        # setup callback for switching steps after loading data
        cb = () =>
            # enable the irrigation steps
            @scope.field_data.zone_steps[0].enabled = true
            step = @enableSteps(@scope.field_data, true)
            @step(step)

        # load irrigation zone if it exists
        if @validation.settings?.year? and @validation.settings?.fid?
            @loadIrrigationZone().then () =>
                # load field data
                @fields.load(cb)
        else
            # load field data
            @fields.load(cb)

    routeAddCrop: () =>
        # route data view
        cb = (result) =>
            @scope.field_data.zone_steps[0].enabled = true
            step = @enableSteps(@scope.field_data, true, true)
            @step(step)

        @loadIrrigationZone().then () =>
            @fields.fields_id = @validation.settings.fid
            @fields.load(cb)

    routeDataView: () =>
        # route data view
        cb = (result) =>
            step = @enableSteps(result, true)
            @step(step)

        @fields.load(cb, 'single', @fields.layers_id)

    loadIrrigationZone: () =>
        return @fields.zones.getIrrigationZoneByFieldYear(@validation.settings.fid, @validation.settings.year).then (response) =>
            if response.data.data
                @scope.field_data.zones.irrigation = response.data.data
                @scope.field_data.zones.irrigation.zones = []
                @scope.field_data.zones.irrigation.loaded_zones = response.data.data.areas

    enableSteps: (data, return_first_enabled = false, skip_first_two_zone_steps = false) =>
        needs_set = true

        for zone_steps in data.zone_steps
            if zone_steps.enabled is true
                for child_step in zone_steps.child_steps
                    # special handling for option step
                    if child_step is 'grower.fields-define.irrigation-details'
                        # add the step if the user has fieldprint access
                        if @scope.field_data.has_fieldprint_access
                            @scope.steps.enableStep(child_step)
                        else
                            continue
                    else if child_step in ['grower.fields-define.irrigation-draw', 'grower.fields-define.irrigation-settings1'] and skip_first_two_zone_steps
                        continue
                    else
                        # normal handling for steps that are required for everyone
                        @scope.steps.enableStep(child_step)

                    if return_first_enabled and needs_set is true
                        needs_set = child_step

        return needs_set

    step: (step) =>
        @scope.steps.gotoStep(step)

    exitProcess: () =>
        @state.go('grower')

    loadIds: () =>
        @http.post('backend/grower/fields/define/load-zone-mdc-ids').then (response) =>
            irrigation_id = null
            productivity_id = null
            previous_crop_id = null

            for k, v of response.data.data
                if k is 'Irrigation'
                    irrigation_id = v
                if k is 'Productivity'
                    productivity_id = v
                if k is 'Previous Crop'
                    previous_crop_id = v

            return [irrigation_id, previous_crop_id, productivity_id]

    findStepsByLayerTitle: () =>
        if /Productivity.*/.test @validation.settings.layers_title
            return [11, 12, 13, 14]

        if /Irrigation.*/.test @validation.settings.layers_title
            return [5, 6, 7, 8, 14]

        if @validation.settings.layers_title is 'Previous Crop'
            return [9, 10, 14]

        if /Previous Crop.*/.test @validation.settings.layers_title
            return [9, 10, 14]

    getStepNumbersByMode: (mode) =>
        # return steps in the right order depending on mode
        switch mode
            # data->view->maps->mmz->edit steps
            when 'zone-edit' then return @findStepsByLayerTitle()
            # data->add->maps->draw steps
            when 'zone-add' then return [4..14]
            # when we want to add only an irrigation zone
            when 'irrigation-add' then return [5, 6, 7, 8, 14]
            # when we have an irrigation zone that we want to add a crop to
            when 'add-crop' then return [7, 8, 14]

    makeSteps: (mode) =>
        # get step numbers to pull based on process mode
        steps_numbers_to_add = @getStepNumbersByMode(mode)

        result = []

        # all steps and step numbers
        steps = [
            # 0
            { state: 'grower.fields-define.locate' }
            # 1
            { state: 'grower.fields-define.identify' }
            # 2
            { state: 'grower.fields-define.clus' }
            # 3
            { state: 'grower.fields-define.boundary' }
            # 4
            { state: 'grower.fields-define.select-management-zones' }
            # 5
            { state: 'grower.fields-define.irrigation-draw', disabled: true }
            # 6
            { state: 'grower.fields-define.irrigation-settings1', disabled: true }
            # 7
            { state: 'grower.fields-define.irrigation-settings2', disabled: true }
            # 8
            { state: 'grower.fields-define.irrigation-details', disabled: true }
            # 9
            { state: 'grower.fields-define.previous-crop-draw', disabled: true }
            # 10
            { state: 'grower.fields-define.previous-crop-settings1', disabled: true }
            # 11
            { state: 'grower.fields-define.productivity-draw', disabled: true }
            # 12
            { state: 'grower.fields-define.productivity-settings1', disabled: true }
            # 13
            { state: 'grower.fields-define.productivity-settings2', disabled: true }
            # 14
            { state: 'grower.fields-define.finish' }

        ]

        # populate result array with steps in order
        for stp, number in steps
            if number in steps_numbers_to_add
                if stp.state is 'grower.fields-define.irrigation-details'
                    # add optional irrigation details step if the user has fieldprint access
                    result.push stp if @scope.field_data.has_fieldprint_access
                else
                    # add steps that are required for everyone
                    result.push stp

        return result



